/** Забежка закрыта — представление без стора, всё приходит пропсами. */
import { Button, Icon, WindowShell } from "../kit";
import { useT } from "../../../app";

export function RunEndedView({ rejected = false, onFight }: { rejected?: boolean; onFight(): void }) {
  const t = useT();
  return (
    <WindowShell kind="runEnded" title={t("win.runEnded.title")}>
      <p class="win-text">{t(rejected ? "win.runEnded.rejected" : "win.runEnded.text")}</p>
      <div class="win-actions">
        <Button tone="green" onClick={onFight} data-testid="run-ended-fight">
          <Icon name="play" size={20} /> {t("win.runEnded.fight")}
        </Button>
      </div>
    </WindowShell>
  );
}
